import { Injectable, signal } from '@angular/core';
import { Capacitor } from '@capacitor/core';

export type PlatformShellMode = 'browser' | 'native';

@Injectable({
  providedIn: 'root'
})
export class PlatformModeService {
  private readonly nativeApp = Capacitor.isNativePlatform();
  private readonly compactViewport = signal(this.readCompactViewport());

  constructor() {
    if (typeof window === 'undefined') {
      return;
    }

    const mediaQuery = window.matchMedia('(max-width: 991.98px)');
    const updateViewport = () => {
      this.compactViewport.set(this.readCompactViewport());
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', updateViewport);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(updateViewport);
    }
  }

  get shellMode(): PlatformShellMode {
    return this.nativeApp ? 'native' : 'browser';
  }

  isNativeApp(): boolean {
    return this.nativeApp;
  }

  isBrowserWeb(): boolean {
    return !this.nativeApp;
  }

  isCompactViewport(): boolean {
    return this.nativeApp || this.compactViewport();
  }

  isWideViewport(): boolean {
    return !this.isCompactViewport();
  }

  private readCompactViewport(): boolean {
    if (this.nativeApp) {
      return true;
    }

    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }

    return window.matchMedia('(max-width: 991.98px)').matches;
  }
}
